import { Component } from '@angular/core';
import {
  RestorationMetricMapWidgetComponent,
} from '../restoration-metric-map-widget/restoration-metric-map-widget.component';

@Component({
  selector: 'tgrid-restoration-metric-recovery-duration-widget',
  imports: [
    RestorationMetricMapWidgetComponent,
  ],
  templateUrl: './restoration-metric-recovery-duration-widget.component.html',
  styleUrl: './restoration-metric-recovery-duration-widget.component.scss',
})
export class RestorationMetricRecoveryDurationWidgetComponent {

}
